"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _reactIntl = require("react-intl");
var _recompose = require("../recompose");
var _excluded = ["intl", "intlKey", "intlValues", "children"];
var _default = exports.default = function _default(base) {
  return (0, _recompose.compose)(_reactIntl.injectIntl, (0, _recompose.mapProps)(function (_ref) {
    var intl = _ref.intl,
      intlKey = _ref.intlKey,
      intlValues = _ref.intlValues,
      children = _ref.children,
      rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
    return Object.assign({}, rest, {
      children: intlKey ? intl.formatMessage({
        id: base + "." + intlKey,
        defaultMessage: children
      }, intlValues) : children
    });
  }));
};